<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'financeAccountAdd',
    components: {
      baseEdit,
    },
  };
</script>
